export const money = (amount: number) =>
  new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN'
  })
    .formatToParts(amount)
    .filter((p) => !['decimal', 'fraction'].includes(p.type))
    .map((p) => p.value)
    .join('')

export function titleCase(str: string) {
  return str.toLowerCase().replace(/\b(\w)/g, (s: string) => s.toUpperCase())
}
